import React, { useEffect, useState } from "react";
import "./ProfilePage.scss";
import { Form, Flex, message } from "antd";
import InputField from "../../Reuseable/InputField/InputField";
import CustomSelect from "../../Reuseable/Select/Select";
import NormalButton from "../../Reuseable/NormalButton/NormalButton";
import DatePickerWithTime from "../../Reuseable/DatePickerWithTime/DatePickerWithTime";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { fetchAgencyProfile } from "../../store/agencySlice";
import { updateProfile } from "../../assets/api/agency";
import CustomNotification from "../../Reuseable/CustomNotification/CustomNotification";

const ProfilePage = () => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { agency_profile } = useSelector((state) => state.agency);
  const [loading, setLoading] = useState(false);
  const token = useSelector((state) => state.auth.token);
  dayjs.extend(utc);
  dayjs.extend(timezone);



  useEffect(() => {
    dispatch(fetchAgencyProfile());
  }, [dispatch]);

  // Map profile data to form fields
  useEffect(() => {
    if (agency_profile && Object.keys(agency_profile).length > 0) {
      form.setFieldsValue({
        companyName: agency_profile.company_name || "",
        dateTime: agency_profile.Date ? dayjs(agency_profile.Date) : null,
        cities: agency_profile.cities ? agency_profile.cities.split(",") : [],
        city: agency_profile.city || "",
        pincode: agency_profile.pin_code || "",
        registeredAddress: agency_profile.registered_address || "",
        registeredCity: agency_profile.registered_city || "",
        agencyStructure: agency_profile.agency_structure || "",
        lineOfBusiness: agency_profile.line_of_business || "",
        panNo: agency_profile.pan_no || "",
        serviceTaxNumber: agency_profile.service_tax_number || "",
        telephone: agency_profile.telephone_number || "",
        functionalArea: agency_profile.functional_area || "",
        presence_in_states: agency_profile.presence_in_states
          ? agency_profile.presence_in_states.split(",")
          : [],
      });
    }
  }, [agency_profile, form]);

  const handleSubmit = async (values) => {
    const payload = {
      // company_name: values.companyName,
      // date: values.dateTime,
      presence_in_states: Array.isArray(values.presence_in_states)
        ? values.presence_in_states.join(",")
        : "",
      cities: Array.isArray(values.cities) ? values.cities.join(",") : "",
      city: values.city,
      pin_code: values.pincode,
      registered_address: values.registeredAddress,
      registered_city: values.registeredCity,
      agency_structure: values.agencyStructure,
      line_of_business: values.lineOfBusiness,
      pan_no: values.panNo,
      service_tax_number: values.serviceTaxNumber,
      telephone_number: values.telephone,
      functional_area: values.functionalArea,
    };

    try {
      setLoading(true);
      await updateProfile(payload, token, agency_profile?.id);
      CustomNotification.show("Agency details updated successfully!");
      dispatch(fetchAgencyProfile());
      setLoading(false);
    } catch (error) {

      CustomNotification.show("Failed to update agency details.");
      setLoading(false);
    }
  };

  return (
    <div className="profilePageMain">
      <div className="profilePageContent">
        <div className="headerSection">
          <h2>Update Agency Details</h2>
        </div>

        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
          autoComplete="off"
        >
          <div className="ProfileContentContainer">
            <div className="agencyInfoContainer">
              <div className="subHeader">
                <h2>Agency Information</h2>
              </div>
              <div className="inputSections">
                <Form.Item
                  name="companyName"
                  className="formItem wrapperSect"
                  rules={[{ required: true, message: "Required" }]}
                >
                  <InputField
                    label="Company Name"
                    placeholder="Enter your Company Name"
                    disabled={true}
                  />
                </Form.Item>

                <Form.Item
                  name="dateTime"
                  className="formItem wrapperSect"
                  rules={[{ required: false, message: "Required" }]}
                >
                  <Flex className="date-time-wrapper">
                    <label className="dateLabel">
                      Registration Date & Time
                    </label>
                    <DatePickerWithTime
                      disabled={true}
                      value={form.getFieldValue("dateTime")}
                      onChange={(date) => form.setFieldValue("dateTime", date)}
                    />
                  </Flex>
                </Form.Item>

                <Form.Item
                  name="presence_in_states"
                  className="formItem wrapperSect"
                  rules={[{ required: true, message: "Select states" }]}
                >
                  <CustomSelect
                    label="Presence in States"
                    placeholder="Select Operational State"
                    isMultiSelect={true}
                    options={[
                      { value: "100001", label: "100001" },
                      { value: "100002", label: "100002" },
                      { value: "100003", label: "100003" },
                    ]}
                  />
                </Form.Item>

                <Form.Item
                  name="cities"
                  className="formItem wrapperSect"
                  rules={[{ required: true, message: "Select cities" }]}
                >
                  <CustomSelect
                    label="Cities"
                    placeholder="Select City"
                    isMultiSelect={true}
                    options={[
                      { value: "Mumbai", label: "Mumbai" },
                      { value: "Delhi", label: "Delhi" },
                      { value: "Chennai", label: "Chennai" },
                    ]}
                  />
                </Form.Item>
              </div>
            </div>

            <div className="locationDetailsContainer">
              <div className="subHeader">
                <h2>Location Details</h2>
              </div>
              <div className="inputSections">
                <Form.Item
                  name="city"
                  className="formItem wrapperSect"
                  rules={[{ required: true, message: "Enter city" }]}
                >
                  <InputField label="City" placeholder="City" />
                </Form.Item>

                <Form.Item
                  name="pincode"
                  className="formItem wrapperSect"
                  rules={[{ required: true, message: "Enter pin code" }]}
                >
                  <InputField label="Pin Code" placeholder="Pin code" />
                </Form.Item>

                <Form.Item
                  name="registeredAddress"
                  className="formItem wrapperSect"
                  rules={[{ required: true, message: "Enter address" }]}
                >
                  <InputField
                    label="Registered Address"
                    placeholder="Address"
                  />
                </Form.Item>

                <Form.Item
                  name="registeredCity"
                  className="formItem wrapperSect"
                  rules={[
                    { required: true, message: "Select registered city" },
                  ]}
                >
                  <CustomSelect
                    label="Registered City"
                    placeholder="Registered city"
                    options={[]}
                  />
                </Form.Item>

                <Form.Item
                  name="agencyStructure"
                  className="formItem wrapperSect"
                  rules={[{ required: false, message: "Select structure" }]}
                >
                  <CustomSelect
                    label="Agency Structure"
                    placeholder="Agency structure"
                  // options={[]}
                  />
                </Form.Item>

                <Form.Item
                  name="lineOfBusiness"
                  className="formItem wrapperSect"
                  rules={[{ required: true, message: "Select business line" }]}
                >
                  <CustomSelect
                    label="Line of Business"
                    placeholder="Line of business"
                    options={[{ value: "collections", label: "Collections" }]}
                  />
                </Form.Item>

                <Form.Item
                  name="panNo"
                  className="formItem wrapperSect"
                  rules={[{ required: true, message: "Enter PAN" }]}
                >
                  <InputField label="PAN No." placeholder="FEEPE3458A" />
                </Form.Item>

                <Form.Item
                  name="serviceTaxNumber"
                  className="formItem wrapperSect"
                  rules={[{ required: true, message: "Enter tax number" }]}
                >
                  <InputField
                    label="Service Tax Number"
                    placeholder="345893459"
                  />
                </Form.Item>

                <Form.Item
                  name="telephone"
                  className="formItem wrapperSect"
                  rules={[{ required: true, message: "Enter number" }]}
                >
                  <InputField
                    label="Telephone Number"
                    addonBefore="+91"
                    placeholder="9999999999"
                  />
                </Form.Item>
              </div>
            </div>

            <NormalButton loading={loading} htmlType="submit">Update Details</NormalButton>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default ProfilePage;
